import RenderHTML from '../../../../../../../components/ui-components/RenderHTML'
import { LumpsumRecommendationActionType } from '../../../api/common.types'

export const RECOMMENDATION_FUNDS_SECTION_INSET_PX = 20

const planRecommendationSellRowIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <rect width="14" height="14" fill="white" fill-opacity="0.0901961"/>
  <path d="M1.10938 7L10.1719 7" stroke="#6A6E6E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.1875 2.01562L10.1719 7L5.1875 11.9844" stroke="#6A6E6E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.8906 11.9844L12.8906 2.01562" stroke="#6A6E6E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const planRecommendationBuyRowIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <rect width="14" height="14" transform="translate(14 14) rotate(-180)" fill="white" fill-opacity="0.0901961"/>
  <path d="M9.85938 7L1.00441 7" stroke="#2A9C4A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.875 12L1.00477 7L5.875 2" stroke="#2A9C4A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13 2L13 12" stroke="#2A9C4A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

type RecommendationFundsSectionTitleProps = {
  title: string
  type: LumpsumRecommendationActionType
  completedCount?: number
}

export function RecommendationFundsSectionTitle({
  title,
  type,
  completedCount = 0
}: RecommendationFundsSectionTitleProps) {
  const titleRowIconSvg =
    type === LumpsumRecommendationActionType.SELL
      ? planRecommendationSellRowIconSvg
      : planRecommendationBuyRowIconSvg

  return (
    <div
      className={`flex items-center justify-between gap-3 pr-5 pb-3 text-[13px] font-[500] leading-[130%]
        ${type === LumpsumRecommendationActionType.SELL ? 'text-[#6A6E6E]' : 'text-[#2A9C4A]'}`}
      style={{ paddingInlineStart: RECOMMENDATION_FUNDS_SECTION_INSET_PX }}
    >
      <div className="flex min-w-0 items-center gap-2">
        <RenderHTML innerHTMLText={titleRowIconSvg} />
        <span>{title}</span>
      </div>
      {completedCount > 0 ? (
        <span className="shrink-0 text-[13px] font-[500] text-[#2A9C4A]">{completedCount} completed</span>
      ) : null}
    </div>
  )
}
